import React from 'react';

interface ComponentProps {
  value: string;
  dataTestId?: string;
}

const ReadonlyInput: React.FC<ComponentProps> = ({ value, dataTestId }) => {
  return (
    <div
      className={
        'flex px-2.5 grow h-[40px] rounded bg-base-tertiary border border-content-quaternary text-content-secondary items-center'
      }
      data-testid={dataTestId}
    >
      {value}
    </div>
  );
};

export default ReadonlyInput;
